import { render, staticRenderFns } from "./PersonaJuridica.vue?vue&type=template&id=772126c3"
import script from "./PersonaJuridica.vue?vue&type=script&lang=js"
export * from "./PersonaJuridica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports